export default {
  host: {
    mptweb: `http://www.mpt.sabah.gov.my`,
    mptgis: `http://178.128.30.22/`,
    epayment: 'https://epayment.menggaris.com'
  },
  AES_SECRET: 'aTWXyJZL7KBdphA7TBk4GHFNBKBSrfyn',
  COUCHDB: 'https://data.menggaris.com',
  WORKER: 'https://api.menggaris.com',
  withCredentials: false,
  withCredentialsWorker: false,
  council: 'mpt',
  publicMode: true,
  demo: {
    auth_demo: {
      password: 'int3rNalSFvjbCQFdZp3HEbBWeJY',
      username: 'couchdb'
    },
    DEMO_WORKER: 'http://localhost:3031',
    DEMO_COUCHDB: 'https://data.menggaris.com/',
    withCredentials: false,
    withCredentialsWorker: false
  }
}
